import {type Configs, useGetConfigsQuery} from "pages/dashboard/api";
import {
  createContext,
  useContext,
  type FC,
  type PropsWithChildren,
} from "react";

type ConfigsContextValue = {
  configs?: Configs;
  loading: boolean;
  error?: unknown;
};

const ConfigsContext = createContext<ConfigsContextValue | undefined>(
  undefined,
);

export const ConfigsProvider: FC<PropsWithChildren> = ({children}) => {
  const {data, loading, error} = useGetConfigsQuery();

  return (
    <ConfigsContext.Provider
      value={{
        configs: data ? data : undefined,
        loading,
        error,
      }}>
      {children}
    </ConfigsContext.Provider>
  );
};

export const useConfigs = (): ConfigsContextValue => {
  const ctx = useContext(ConfigsContext);
  if (!ctx) {
    throw new Error("useConfigs must be used within ConfigsProvider");
  }
  return ctx;
};
